import { Injectable } from '@angular/core';
import { StoreService } from '../store/store.service';
import { ProfileService } from '../profile/profile.service';
import { map, first, startWith } from 'rxjs/operators';
import { merge, Observable, combineLatest } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { MergeMapOperator } from 'rxjs/internal/operators/mergeMap';

@Injectable({
  providedIn: 'root',
})
export class TestResultService {
  constructor(
    private store: StoreService,
    private profileService: ProfileService,
    private authService: AuthService,
  ) {}

  public getTestResult(): Observable<CalculationResult> {
    const testResultInStore = this.store.testResult.asObservable();

    const user$ = this.profileService.user().pipe(startWith([undefined]));
    const testResultInProfile = user$.pipe(
      map((user: any) => (user ? user.testResult : undefined)),
      startWith([undefined]),
    );

    return combineLatest([testResultInStore, testResultInProfile]).pipe(
      map(([store, profile]) => profile || store),
    );
  }

  public setTestResult(testResult: CalculationResult): Promise<void> {
    return this.authService
      .isLoggedIn()
      .pipe(first())
      .toPromise()
      .then((isLoggedIn) => {
        if (isLoggedIn) {
          // Save test result to profile and store
          this.profileService.updateUserDocument({
            testResult,
          });
          this.store.testResult.next(testResult);
        } else {
          // Save test result only  to store
          this.store.testResult.next(testResult);
        }
      });
  }
}
